import {useLogger, useSharedState} from '@deliveryhero/vendor-web-core';
import {jwtDecode} from 'jwt-decode';
import {useMemo} from 'react';
import {AUTH_STATE, TokenInfo, AuthStateSlice} from '../interfaces/AuthState';

export const usePlatforms = (): string[] => {
  const accessToken = useSharedState<string | undefined>(
    (state) => (state[AUTH_STATE] as AuthStateSlice | undefined)?.accessToken,
  );
  const logger = useLogger();

  return useMemo(() => {
    if (accessToken === undefined) {
      // TODO: change to Sentry breadcrumb
      logger.warning('usePlatforms: no accessToken data', {}, {});
      return [];
    }
    try {
      const decodedAccessToken: TokenInfo = jwtDecode<TokenInfo>(accessToken);
      const tokenPlatforms = decodedAccessToken.metadata.platforms;
      const tokenLpvid = decodedAccessToken.metadata.lpvid;

      // no lpvid means "onboarding" vendor, the availability doesn't work,
      // from the logs can be seen that no platforms is also a common case for multi-vendor with ~ >100 restaurants
      if (tokenPlatforms === undefined || tokenLpvid === undefined) {
        // TODO: add Sentry breadcrumb
        return [];
      } else {
        return tokenPlatforms;
      }
    } catch (error) {
      logger.error('usePlatforms: accessToken decode error: ', error, {});
      return [];
    }
  }, [accessToken, logger]);
};
